import { observer } from 'mobx-react';
import * as React from 'react';
import FlashMessage from '../components/FlashMessage';
import { error } from '../ErrorHandling';
import { errorAlert } from '../Notifications/Types';
import { LoginStore } from './Store';

interface Props {
  store: LoginStore;
}

const ErrorMessage: React.FC<Props> = ({ store }) => {
  switch (store.state.kind) {
    case 'waiting':
    case 'redirecting':
      return <></>;
    case 'errored':
      return (
        <FlashMessage
          alert={errorAlert(error('An error occurred, please refresh the page and try again'))}
        />
      );
  }
};

export default observer(ErrorMessage);
